import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'

export const api = {
  sendVerificationCode: ipConfig.api_mwclg + '/mcp/user/sendVerificationCode', // 获取邮箱验证码
  retrievePassword: ipConfig.api_mwclg + '/mcp/user/retrievePassword' // 重置密码
}

// 获取邮箱验证码
export function sendVerificationCode (data) {
  return axios({
    url: api.sendVerificationCode,
    method: 'post',
    data
  })
}

// 重置密码
export function retrievePassword (data) {
  return axios({
    url: api.retrievePassword,
    method: 'post',
    data
  })
}
